import { snakeStore } from '@app/plugins/vuex-async-pagginate';
import { DataBaseService } from '@db/services/DataBaseService';
import uniqBy from 'lodash-es/uniqBy';

export const table = snakeStore(
  {
    state: {
      selected: []
    },
    mutations: {
      selected: (state, value) => (state['selected'] = uniqBy(value, 'id') || [])
    },
    getters: {
      selected: state => state['selected'] || [],
      data: (state, getters) => {
        const { keys } = state;
        const selected_ids = getters.selected.map(i => i.id);
        return (state[keys.data] || []).map(m => ({
          ...m,
          selected: selected_ids.includes(m.id),
          range: [0, m.recipients_count]
        }));
      }
    },
    actions: {
      getData: (_, params) => DataBaseService.getList(params),
      addDataBase: ({ commit, getters }, val) => commit('selected', [...getters.selected, val]),
      removeDataBase: ({ commit, getters }, val) =>
        commit(
          'selected',
          getters.selected.filter(f => f.id !== val.id)
        )
    }
  },
  true
);
